{
  "bookmarkTitleLabel": "Signets",
  "debug": "Déboguer",
  "devConnectionLabel": "Developer Connection",
  "exlSection": "Résultats d'Experience League",
  "feedback": "Commentaires",
  "fetchFailed": "Échec de la récupération",
  "help": "Aide",
  "helpDefaultFeatured": "Formation et assistance Adobe Experience Cloud",
  "helpLoadError": "Une erreur est survenue. Veuillez réessayer.",
  "noBookmarks": "Marquer d’un signet le contenu d’aide pour y accéder ici",
  "noBookmarksTitle": "Pas de signets",
  "noResults": "Aucun résultat trouvé",
  "noResultsMessage": "Vérifiez l’orthographe ou essayez un autre terme de recherche.",
  "resourcesCustomerCareLabel": "Assistance clientèle",
  "resourcesStatusLabel": "Statut",
  "support": "Support"
}
